import styled from 'styled-components';

const ModalBody = styled.div`
  position: relative;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  padding: 1rem;
`;

export default ModalBody;



// WEBPACK FOOTER //
// client/components/Modal/ModalBody.js